// Article metadata for the application
export interface Article {
  title: string
  slug: string
  description: string
}

// Export the article list for use throughout the application
export const articles: Article[] = [
  {
    title: 'Setting Up Recurring Reminders in Microsoft Teams: Step-by-Step Tutorial with TeamsReminder',
    slug: 'recurring-reminders-microsoft-teams-tutorial',
    description: 'Learn how to set up recurring reminders in Microsoft Teams with this comprehensive tutorial for the TeamsReminder app, including steps for daily, weekly and monthly reminders.'
  },
  {
    title: 'TeamsReminder vs Native Teams Reminders: A Comprehensive Comparison',
    slug: 'teamsreminder-vs-native-teams-reminders-comparison',
    description: 'Compare TeamsReminder with native Microsoft Teams reminder capabilities to understand the advantages and when to use each option for your team communication needs.'
  },
  {
    title: 'Remote Team Productivity Guide with TeamsReminder',
    slug: 'teamsreminder-remote-team-productivity-guide',
    description: 'Discover how to boost remote team productivity using TeamsReminder to maintain communication consistency, automate follow-ups, and enhance accountability.'
  },
  {
    title: 'Managing Cross-Departmental Communication with TeamsReminder Channels: A Strategic Guide',
    slug: 'cross-departmental-communication-teamsreminder-channels',
    description: 'Learn how to improve cross-departmental communication and collaboration using TeamsReminder channels in Microsoft Teams with strategic reminders and structured workflows.'
  },
  {
    title: 'Using TeamsReminder to Meet Compliance and Regulatory Deadlines in Financial Services',
    slug: 'teamsreminder-financial-compliance-regulatory-deadlines',
    description: 'Learn how financial services professionals can use TeamsReminder to effectively manage compliance and regulatory deadlines through automated notifications and team visibility.'
  },
  {
    title: 'TeamsReminder for Project Management: How to Never Miss Another Deadline',
    slug: 'teamsreminder-project-management-deadline-tracking',
    description: 'Learn how project managers can use TeamsReminder to effectively track project deadlines, coordinate team efforts, and ensure on-time delivery with automatic reminders in Microsoft Teams.'
  },
  {
    title: 'TeamsReminder for HR: Streamlining Employee Onboarding and Performance Reviews',
    slug: 'teamsreminder-hr-onboarding-performance-reviews',
    description: 'Learn how HR professionals can use TeamsReminder to create consistent onboarding experiences and streamline performance review processes within Microsoft Teams.'
  },
  {
    title: 'TeamsReminder for Customer Success: A System for Flawless Client Follow-ups',
    slug: 'teamsreminder-customer-success-client-followups',
    description: 'Learn how customer success teams can use TeamsReminder to manage client relationships with consistent follow-ups, onboarding sequences, and renewal reminders in Microsoft Teams.'
  },
  {
    title: 'TeamsReminder Mobile: A Complete Guide to Managing Your Team On-the-Go',
    slug: 'teamsreminder-mobile-management-guide',
    description: 'Learn how to effectively use TeamsReminder\'s mobile capabilities to manage team reminders, schedule notifications, and coordinate work while away from your desk.'
  },
  {
    title: 'Integrating TeamsReminder with Your Existing Workflow Tools: A Comprehensive Guide',
    slug: 'integrating-teamsreminder-workflow-tools-guide',
    description: 'Learn how to integrate TeamsReminder with project management tools, calendars, CRM systems, and more to create a seamless workflow environment within Microsoft Teams.'
  },
  {
    title: 'TeamsReminder Free vs. Premium: A Detailed Analysis of Whether the Upgrade Is Worth It',
    slug: 'teamsreminder-free-vs-premium-comparison',
    description: 'Compare TeamsReminder\'s free and premium tiers to determine if upgrading is right for your organization. Detailed feature comparison, ROI analysis, and guidance for teams of all sizes.'
  }
];

// Map of article image extensions - only add exceptions to the default 'png'
export const articleImageExtensions: Record<string, string> = {
  'cross-departmental-communication-teamsreminder-channels': 'webp'
};

// Function to get article metadata by slug
export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find(article => article.slug === slug);
}

// Function to get the appropriate image extension for an article
export function getArticleImageExtension(slug: string): string {
  return articleImageExtensions[slug] || 'png';
}